module.exports = __webpack_public_path__ + "media/bootstrap-icons/border-0a0aefe3.svg";